import { render } from "./StopPointTime.vue?vue&type=template&id=c8b6dfb8"
import script from "./StopPointTime.vue?vue&type=script&lang=ts"
export * from "./StopPointTime.vue?vue&type=script&lang=ts"
script.render = render

export default script